module.exports = __webpack_public_path__ + "img/feature-4.4fed5863.jpg";